<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">.</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div
        v-if="loading"
        style="
          font-size: 1.5em;
          display: flex;
          justify-content: center;
          align-items: center;
          color: black;
        "
      >
        Loading...
      </div>
      <div v-if="!loading" class="modal-body">
        <!-- <div class="patient-profile"> -->
        <div class="profile-header"></div>
        <div class="profile-details">
          <div
            style="
              /* display: flex; */
              justify-content: center;
              align-items: center;
              color: black;
            "
          >
            <p
              style="
                font-size: 1.3em;
                gap: 10px;
                font-weight: bold;
                display: block;
              "
            >
              Confirm that you want to close this invoice by ID:
              {{ invoice_id }} ?
            </p>
            <p style="font-size: 1.2em; background-color: rgb(231, 232, 223)">
              By this action, you will not be able to add Items or edit the
              contents of this Invoice any more
            </p>
          </div>
        </div>
        <!-- </div>  -->
      </div>
      <div v-if="!loading" class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" @click="closeModal">
          Close
        </button> -->
        <button type="button" class="btn btn-danger" @click="confirm_closure">
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "ModalContent",
  data() {
    return {
      loading: false,
    };
  },
  props: {
    invoice_id: {
      type: [String, Number],
      required: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-inv-modal");
    },
    async confirm_closure() {
      this.loading = true;
      const url = "close_invoice/" + this.invoice_id;
      await generalApiRequest(url, "GET", {}, 1);
      this.loading = false;
      this.closeModal();
    },
  },

  mounted() {
    console.log(this.patient_id);
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto; /* Scrollable content */
  flex-grow: 1; /* Allow the body to grow and take available space */
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.patient-profile {
  margin: 0;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

/*  */
</style>
